import { EXISTS, REMOVED, INACTIVE } from '../definitions/entityStatus';

export function isOperatorActive(status) {
  return status === EXISTS;
}

export function isOperatorDeleted(status) {
  return status === REMOVED;
}

export function operatorStatusLabel(status) {
  return status === INACTIVE ? 'Inactive' : isOperatorDeleted(status) ? 'Deleted' : 'Active';
}

export function operatorStatusVariant(status) {
  return status === INACTIVE ? 'warning' : isOperatorDeleted(status) ? 'danger' : 'success';
}
